module.exports = __webpack_public_path__ + "img/avatar10.c6eb1c72.jpg";